// {
//   useEFun: true,
//   eFunResponse: {"marketCd":"TP","orderInfo":[{"orderNo":"15091","tickets":[{"ticketAmount":1700,"couponIds":["20211004210210122833"],"seqNo":"0000015750T00001","deductAmount":100},{"ticketAmount":1700,"couponIds":["20211004210210122844"],"seqNo":"0000015750T00002","deductAmount":100}]}],"caseSeq":"1101001974"}
// };

// {"marketCd":"TP","orderInfo":[{"orderNo":"15104","tickets":[{"ticketAmount":3300,"couponIds":["20211004210210122931"],"seqNo":"0000015764T00001","deductAmount":100},{"ticketAmount":3300,"couponIds":["20211004210210122942","20211004210210122953"],"seqNo":"0000015764T00002","deductAmount":200},{"ticketAmount":3650,"couponIds":["20211004210210122964","20211004210210122975","20211004210210122986"],"seqNo":"0000015765T00001","deductAmount":300}]}],"caseSeq":"1102002006"}
const getDefaultState = () => {
  return {
    couldCulturePoint: false,
    useCulturePoint: false,
    culturePointResponse: null
  };
};

//init state
const state = getDefaultState();

const mutations = {
  SET_COULD_CULTURE_POINT: (state, status) => {
    state.couldCulturePoint = status;
  },
  SET_USE_CULTURE_POINT: (state, status) => {
    state.useCulturePoint = status;
  },
  SET_RESPONSE: (state, data) => {
    state.culturePointResponse = data;
  },
  SET_DEFAULT: (state, data) => {
    state.useCulturePoint = false;
    state.culturePointResponse = null;
  }
};

const actions = {
  //show snackbar
  canCulturePoint({ commit }, status) {
    commit("SET_COULD_CULTURE_POINT", status);
  },
  use({ commit }, status) {
    commit("SET_USE_CULTURE_POINT", status);
  },
  setResponse({ commit }, data) {
    commit("SET_RESPONSE", data);
  },
  resetCulturePoint({ commit }) {
    console.log("SET_DEFAULT");
    commit("SET_DEFAULT");
  }
};

const getters = {
  couldCulturePoint: state => state.couldCulturePoint,
  useCulturePoint: state => state.useCulturePoint,
  culturePointResponse: state => state.culturePointResponse
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
